import { CAMPAIGN_STATUS } from '@app/constant/CampaignConstant'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import EditIcon from '@mui/icons-material/Edit'
import PageviewIcon from '@mui/icons-material/Pageview'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'
import ButtonChangeStatus from '../../../../components/ButtonChangeStatus'
import DataGrid from '../../../../components/organisms/DataGrid/DataGrid'

export default function CampaignIndex({ campaigns }) {
  const { t } = useTranslation()
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('CAMPAIGNS.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'partner_name',
              Header: t('CAMPAIGNS.PARTNER'),
              accessor: 'partner_name',
              type: 'string',
            },
            {
              id: 'merchants_count',
              Header: t('CAMPAIGNS.TOTAL_MERCHANTS'),
              accessor: 'merchants_count',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'vouchers_count',
              Header: t('CAMPAIGNS.TOTAL_VOUCHERS'),
              accessor: 'vouchers_count',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'total_costs',
              Header: t('CAMPAIGNS.TOTAL_COST'),
              accessor: 'total_costs',
              type: 'number',
              autoHide: true,
              disableFilters: true,
            },
            {
              id: 'line_of_credit',
              Header: t('CAMPAIGN.LINE_OF_CREDIT'),
              accessor: 'line_of_credit',
              type: 'number',
              autoHide: true,
              disableFilters: true,
            },
            {
              id: 'codes_count',
              Header: t('CAMPAIGNS.TOTAL_CODES'),
              accessor: 'codes_count',
              type: 'number',
              autoHide: true,
              disableFilters: true,
            },
            {
              id: 'remain_time',
              Header: t('CAMPAIGNS.REMAIN_TIME'),
              accessor: ({ start_at, end_at }) => ({ start_at, end_at }),
              type: 'remainingTime',
              disableFilters: true,
              disableSortBy: true,
            },
            {
              id: 'status',
              Header: t('CAMPAIGNS.STATUS'),
              accessor: ({ status }) => t(`CAMPAIGNS.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: CAMPAIGN_STATUS.ACTIVE, name: t('CAMPAIGNS.ACTIVE') },
                { value: CAMPAIGN_STATUS.IN_ACTIVE, name: t('CAMPAIGNS.INACTIVE') },
              ],
              Cell: ({ row }) => (
                <ButtonChangeStatus
                  handleSubmit={() => {
                    Inertia.get(
                      route('admin.campaigns.status.change', { campaign: row.original.id, status: row.original.status })
                    )
                  }}
                  row={row}
                  tableName={t('CAMPAIGNS.CAMPAIGN_TABLE')}
                />
              ),
            },
            {
              id: 'action',
              Header: t('CAMPAIGNS.ACTIONS'),
              disableFilters: true,
              align: 'center',
              cell: {
                style: { whiteSpace: 'nowrap' },
              },
              Cell: ({ row }) => (
                <>
                  <IconButton component={InertiaLink} href={route('admin.campaigns.show', row.original.id)}>
                    <PageviewIcon />
                  </IconButton>
                  <IconButton component={InertiaLink} href={route('admin.campaigns.edit', row.original.id)}>
                    <EditIcon />
                  </IconButton>
                </>
              ),
            },
          ]}
          data={campaigns}
          routeName="admin.campaigns.index"
        />
      </Grid>
    </Grid>
  )
}
